//////////////////////////////////////////////
//! AnimationsView 
//////////////////////////////////////////////

AnimationsView = function( dispatcher ) {

//--------------------------------------------
//! Static Vars
//--------------------------------------------

	

//--------------------------------------------
//! Vars
//--------------------------------------------
	this.dispatcher = dispatcher;

//--------------------------------------------/
	this.init();

};

AnimationsView.prototype = {

	constructor : AnimationsView,

	/*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/

	init : function() {		
		this.createLandingAnimation()
	},

	/*---------------------------------------------------
		FUNCTIONS 
	--------------------------------------------------*/
	introPreloader : function(){
		this.dispatcher.dispatch( EVENTS.TRACKING_PAGE ,"landing_page" );
		if(app.pageHeights !=  null){
			this.repeat = 1;
			this.introPreloader = new TimelineMax({delay:0.1})
			.fromTo($(dom.header),0.2,{y:-20,alpha:0},{y:0,ease: Power4.easeInOut,alpha:1},"intro")
			.fromTo($(dom.footer),0.2,{y:20,alpha:0},{y:0,ease: Power4.easeInOut,alpha:1},"intro")
			.fromTo($(dom.preloader.word),0,{alpha:0},{ease: Power4.easeInOut,delay:0.5,alpha:1})
			.fromTo($(dom.preloader.list),0,{alpha:0},{ease: Power4.easeInOut,delay:0.5,alpha:1,onComplete:function(){
				this.animateLoader();
			}.bindX( this )})
		}

	},
	
	animateLoader : function(){
		var children = $(dom.preloader.list).children().length -1;

		if(this.repeat >= children){
			this.outroPreloader();
			return;
		} 
		var y = - ($($(dom.preloader.list).children()[0]).height() );
		TweenMax.to( $(dom.preloader.list) , 0.3 , { ease: Power4.easeInOut,delay:0.5,y: "+="+y, onComplete:function(){
			this.animateLoader();
			this.repeat++;
		}.bindX(this)})
	},

	outroPreloader : function(){
		TweenMax.to($(dom.preloader.word),0.4,{delay:0.2,alpha:0,ease: Power4.easeInOut})
		TweenMax.to($(dom.preloader.list),0.4,{delay:0.2,alpha:0,ease: Power4.easeInOut,onComplete:function(){
			this.animateLanding();
		}.bindX( this )})
	},

	createLandingAnimation : function(){
		this.landing = new TimelineMax()
		.fromTo($(dom.landing.container),0.75,{x:"140%"},{x:"0%",ease: Power4.easeInOut},"1")
		.fromTo($(dom.navigation.container),0.75,{x:"140%"},{x:"0%",ease: Power4.easeInOut},"1")
		this.landing.pause();
	},

	animateLanding: function(){
		if(app.pageHeights !=  null){
			$(dom.preloader.container).removeClass("is-shown");
			$(dom.landing.container).addClass("is-shown");
		//	$(dom.blocker).addClass("is-shown");
			this.landing.play()
		}
	},

	moveFoward : function(current,next){
		$(dom.blocker).addClass("is-shown");
		next.addClass("is-shown");
		var margin = parseInt(current.css("marginTop"))
		TweenMax.set(next,{y:-app.pageHeights.body-margin});

		TweenMax.set($(dom.navigation.container),{y:-app.pageHeights.body-margin});
		TweenMax.fromTo(current,0.75,{x:"0%"},{x:"-140%",ease: Power4.easeInOut})
		TweenMax.fromTo(next,0.75,{x:"140%"},{x:"0%",ease: Power4.easeInOut,onComplete:function(){
			current.removeClass("is-shown");
			TweenMax.set(next,{y:0});
			TweenMax.set($(dom.navigation.container),{y:0});
			$(dom.blocker).removeClass("is-shown");
		}})
	},

	moveBackwards : function( current , next,share ){
		$(dom.blocker).addClass("is-shown");
		next.addClass("is-shown");
		var margin = parseInt(current.css("marginTop"))
		TweenMax.set(current,{y:-next.height()-margin});
		if(!share)TweenMax.set($(dom.navigation.container),{y:-current.height()-margin});
		else TweenMax.set($(dom.navigation.container),{y:-current.height()});
		TweenMax.fromTo(current,0.75,{x:"0%"},{x:"140%",ease: Power4.easeInOut})
		TweenMax.fromTo(next,0.75,{x:"-140%"},{x:"0%",ease: Power4.easeInOut,onComplete:function(){
			current.removeClass("is-shown");
			TweenMax.set(current,{y:0});
			$(dom.blocker).removeClass("is-shown");
			TweenMax.set($(dom.navigation.container),{y:0});
		}})
	}
	
	/*---------------------------------------------------
		EVENT HANDLERS 
	--------------------------------------------------*/

};
